module.exports = __webpack_public_path__ + "img/fibre.f418d144.jpg";